import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import SmsTemplateAPI from '../../../api/SmsTemplateAPI';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class SmsTemplateList extends React.Component {

  constructor(props) {
    super(props);
    this.smses = [];
    this.state = { ...this.state, sms: {}, popup: false, inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).sms_temp;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() {
    if (this.List) SmsTemplateAPI.list(this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = smses => { this.smses = smses; this.setState({ inApiCall: false }); };

  show = i => {
    const sms = i === -1 ? { id: 0, name: '', text: '' }
      : { id: this.smses[i].id, name: this.smses[i].name, ref: this.smses[i].ref, text: this.smses[i].text };
    this.setState({ ...this.state, sms: { ...sms }, popup: true });
  };
  hide = () => { this.setState({ ...this.state, popup: false }); };
  save = () => {
    if (this.state.sms.name.trim().length === 0) return;

    this.setState({ ...this.state, popup: false, inApiCall: true });
    SmsTemplateAPI.save(this.state.sms, this.success, this.onFail);
  };
  success = () => SmsTemplateAPI.list(this.onReceived, this.onFail);
  nameChange = val => this.setState({ ...this.state, sms: { ...this.state.sms, name: val } });
  refChange = val => this.setState({ ...this.state, sms: { ...this.state.sms, ref: val } });
  textChange = val => this.setState({ ...this.state, sms: { ...this.state.sms, text: val } });

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.smses[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        SmsTemplateAPI.delete(this.smses[index].id, this.onDelete, this.onFail);
      });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Sms Template Deleted successfully', 'success');
    SmsTemplateAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const smsUI = this.smses.map((sms, _i) => (
      <tr key={`product_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{sms.name}</td>
        <td>{sms.ref}</td>
        <td>{sms.text}</td>
        <td>{Display.ModelLabelValue('user', sms.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(sms.created_date)}</td>
        <td>{Display.ModelLabelValue('user', sms.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(sms.updated_date)}</td>
        <td>
          {this.Update &&
            <span className="buttons update" onClick={() => this.show(_i)}>
              <FaPencilAlt /> Update</span>
          }
          {sms.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete</span>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">SMS Template</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    className="mr-sm-2"
                    value={this.state.sms.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Reference/Template Id</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Reference/Template Id"
                    className="mr-sm-2"
                    value={this.state.sms.ref}
                    onChange={event => this.refChange(event.target.value)} />
                </Col>
                <Col xs={12}>
                  <Form.Label>Text</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Text"
                    className="mr-sm-2"
                    value={this.state.sms.text}
                    onChange={event => this.textChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 pb-3"><h3>SMS Templates</h3></div>
              <div className="col-md-8 text-right">
                {this.Add &&
                  <span className="success buttons pcat" onClick={() => this.show(-1)}>
                    + Add Template</span>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Reference/Template Id</th>
                      <th>Text</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th className="th-width">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {smsUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(SmsTemplateList);
